<template>
  <div>
    <div class="title">Red Bull Tournament</div>
    <p class="text-xs-center mt-3" v-if="!isRegistred">
      Только зарегистрированные пользователи могут участвовать в турнире.<br />
      Для регистрации необходимо заполнить все поля формы.<br />
    </p>
    <div class="divider"></div>
    <div class="user-profile__content">
      <div class="user-profile__form container px-0 grid-list-lg">
        <!-- <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">ID в Discord:</div>
          </div>
          <div class="flex xs12 offset-sm2 sm8 form-fields">
            <input
              type="text"
              class="form-input"
              placeholder="Ваш ID в Discord, например: Nickname#1234"
              :readonly="isRegistred"
              v-model="model.discord_id"
            />
          </div>
        </div> -->

        <div class="form-row layout row wrap">
          <div class="flex xs12 offset-sm2 sm8 form-fields">
            <CitySelector v-model="model.city" placeholder="Выберите город" />
          </div>
        </div>

        <!-- <div class="flex xs12 sm4 d-flex align-center">
          <div class="form-label">ID в Discord:</div>
        </div>
        <div class="flex xs12 sm8 form-fields pt-0 layout row wrap">
          <div class="flex xs12">
            <input
              type="text"
              class="form-input"
              placeholder="Ваш ID в Discord, например: Nickname#1234"
              :readonly="isRegistred"
              v-model="model.discord_id"
            />
          </div>
        </div> -->

        <div class="form-row layout row wrap">
          <div class="flex xs12 offset-sm2 sm8 form-fields">
            <FormSwitch
              :readonly="isRegistred"
              v-model="confirmAge"
              label="Подтверждаю, что мне исполнилось 16 лет"
            />
          </div>
        </div>
        <div class="form-row layout row wrap">
          <div class="flex xs12 offset-sm2 sm8">
            <FormSwitch :readonly="isRegistred" v-model="confirmPolicy">
              <template #label>
                <div class="form-text">
                  <p>
                    Я даю свое добровольное согласие на предоставление и
                    дальнейшую обработку моих персональных данных ООО «Ред Булл
                    (Рус)» в соответствии с целями, перечисленными в
                    <a
                      target="_blank"
                      @click.stop=""
                      href="https://policies.redbull.com/policies/RedBull.com_Russia/201907010152/ru/privacy.html"
                    >
                      Положении о конфиденциальности компании Red Bull.
                    </a>
                  </p>
                </div>
              </template>
            </FormSwitch>
          </div>
        </div>

        <div class="user-profile__help">
          По любым вопросам обращайтесь в наш
          <a
            href="https://discord.gg/GNAVsJD"
            target="_blank"
            class="app-link_theme_warm"
            >Дискорд-канал</a
          >
          и в группу в
          <a
            href="https://vk.com/redbullgaming"
            class="app-link_theme_warm"
            target="_blank"
            >ВК</a
          >
        </div>

        <div class="flex xs12 form-row layout row align-center justify-center">
          <app-btn
            :disabled="!valid"
            :loading="processing"
            round
            type="submit"
            color="orange-grad"
            class="px-4"
            @click="submit"
          >
            <span>Продолжить</span>
          </app-btn>

          <!-- <AppBtn
            :loading="loading"
            round
            color="orange-grad"
            class="px-4"
            type="submit"
            @click="submit"
          >
            <span>Зарегистрироваться</span>
          </AppBtn> -->
        </div>

        <!-- <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">ID в Discord:</div>
          </div>
          <div class="flex xs12 sm8 form-fields pt-0 layout row wrap">
            <div class="flex xs12">
              <input
                type="text"
                class="form-input"
                placeholder="Ваш ID в Discord, например: Nickname#1234"
                :readonly="isRegistred"
                v-model="model.discord_id"
              />
            </div>
            <div class="flex xs12 ma-0 layout row align-start">
              <FormSwitch :readonly="isRegistred" v-model="confirmPolicy">
                <template #label>
                  <div class="form-text">
                    <p>
                      Я даю свое добровольное согласие на предоставление и
                      дальнейшую обработку моих персональных данных ООО «Ред
                      Булл (Рус)» в соответствии с целями, перечисленными в
                      <a
                        target="_blank"
                        @click.stop=""
                        href="https://policies.redbull.com/policies/RedBull.com_Russia/201907010152/ru/privacy.html"
                      >
                        Положении о конфиденциальности компании Red Bull.
                      </a>
                    </p>
                  </div>
                </template>
              </FormSwitch>
            </div>
          </div>

          <div
            v-if="!isRegistred"
            class="flex xs12 form-row layout row align-center justify-center"
          >
            <app-btn
              :disabled="!valid"
              :loading="processing"
              @click="submit"
              round
              color="orange-grad"
              class="px-4"
              >Зарегистрироваться</app-btn
            >
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import FormSwitch from "@/components/ui/form/FormSwitch";
import authSerivce from "@/services/auth";
import showAlert from "@/services/common/showAlert";
import clone from "lodash/clone";
import pickBy from "lodash/pickBy";
// import { VueMaskDirective } from "v-mask";

import CitySelector from "@/components/ui/CitySelector";

export default {
  name: "UserProfileModal",
  components: { FormSwitch, CitySelector },
  // directives: { mask: VueMaskDirective },
  props: {
    user: {
      type: Object,
      required: false
    },
    isRegistred: Boolean
  },

  data() {
    return {
      processing: false,
      model: clone(this.user) || {},
      confirmAge: false,
      confirmPolicy: false
    };
  },

  computed: {
    requiredFields() {
      return [
        "city"
        // "name",
        // "surname",
        // "phone_code",
        // "phone_number",
        // "vk_id",
        // "discord_id"
      ];
    },

    toSend() {
      return pickBy(
        this.model,
        (value, key) => !!value && this.requiredFields.includes(key)
      );
    },

    valid() {
      return (
        !this.processing &&
        this.confirmAge &&
        this.confirmPolicy &&
        Object.keys(this.toSend).length >= this.requiredFields.length // &&
        // this.toSend.phone_code.length >= 3 &&
        // this.toSend.phone_number.length == 9
      );
    }
  },

  // watch: {
  //   "model.phone_code": function() {
  //     if (
  //       this.model.phone_code &&
  //       this.model.phone_code.length >= 3 &&
  //       (!this.model.phone_number || this.model.phone_number.length < 9)
  //     ) {
  //       this.$refs.phone_number.focus();
  //     }
  //   }
  // },

  methods: {
    // async submit() {
    //   if (!this.valid) return;

    //   this.$modals.close(true);
    // }

    async submit() {
      if (!this.valid || this.processing) return;
      this.processing = true;

      let data = await authSerivce.register(this.toSend);

      if (data.success) {
        await this.$store.dispatch("auth/getProfile");
        this.$modals.close(true);
      }
      this.processing = false;

      this.$nextTick(() => {
        if (data.message) showAlert(data.message, 2500);
      });
    }
  }
};
</script>

<style lang="scss">
.user-profile {
  &__help {
    font-size: 14px;
    text-align: center;
    margin: 5px 0 20px;
  }

  @include breakpoint("sm-and-down") {
    &__help {
      font-size: 12px;
    }
  }
}
</style>
